import React, { useState } from 'react';
import CalendarCore from './Core';

const now = new Date();
const month = now.getMonth();
const year = now.getFullYear();

const initialPeriod = {
  year,
  month,
};

const EventCalendar = props => {
  const [period, setPeriod] = useState(initialPeriod);
  return <CalendarCore period={period} setPeriod={setPeriod} {...props} />;
};

export default EventCalendar;
